import Actions from '../actions/actions';
import SponsoredMessageCRUDActions from '../actions/SponsoredMessageCRUDActions';
import { SponsoredMessagesState } from '../interfaces/sponsoredMessages';
import {
  deleteLocalFirst,
  retrieved,
  retrievedAll,
  setBusy,
  setUnBusy,
  update,
} from './common/commonReducers';

const initialState: SponsoredMessagesState = {
  busy: false,
  entities: [],
};

export default function sponsoredMessages(
  state: SponsoredMessagesState = initialState,
  action: any,
): SponsoredMessagesState {
  switch (action.type) {
    case SponsoredMessageCRUDActions.busyAction:
      return setBusy(state);
    case SponsoredMessageCRUDActions.unbusyAction:
      return setUnBusy(state);
    case SponsoredMessageCRUDActions.retrievedAction:
      return retrieved(state, action);
    case SponsoredMessageCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case SponsoredMessageCRUDActions.updateAction:
      return update(state, action);
    case SponsoredMessageCRUDActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
